import {
  IPosition,
  IRawApiCompatibilityReport,
  IRawGraph,
  IRawMatrix,
} from '../member/member.types';
import {
  EMatrixType,
  ICompatibilityReport,
  IGraph,
  IMatrix,
  TMatrixDimension,
} from './compatibilityReport.types';

export const compatibilityReportSerializer = ({
  data: {
    attributes: { analysis, graphes },
  },
}: IRawApiCompatibilityReport): ICompatibilityReport => ({
  analysis,
  graphes: graphes.map(graphesSerializer),
});

export const getMatrixType = (
  dimension: TMatrixDimension,
  viewer: IPosition
): EMatrixType => {
  if (dimension === 1) {
    if (viewer.y !== undefined) return EMatrixType.VERTICAL;

    return EMatrixType.HORIZONTAL;
  }

  return EMatrixType.MATRIX;
};

export const getTranslationKeys = (
  graphId: string,
  matrix: IRawMatrix,
  type: EMatrixType
) => {
  switch (type) {
    case EMatrixType.MATRIX:
      return [
        `${graphId}-${matrix.left_top_label_key}`,
        `${graphId}-${matrix.right_top_label_key}`,
        `${graphId}-${matrix.left_bottom_label_key}`,
        `${graphId}-${matrix.right_bottom_label_key}`,
      ];
    case EMatrixType.HORIZONTAL:
      return [
        `${graphId}-${matrix.left_label_key}`,
        `${graphId}-${matrix.right_label_key}`,
      ];
    case EMatrixType.VERTICAL:
      return [
        `${graphId}-${matrix.bottom_label_key}`,
        `${graphId}-${matrix.top_label_key}`,
      ];
    default:
      return [];
  }
};

const matricesSerializer = (graphId: string) => (
  matrix: IRawMatrix
): IMatrix => {
  const { dimension, viewer, viewee } = matrix;
  const type = getMatrixType(dimension, viewer);
  const translationKeys = getTranslationKeys(graphId, matrix, type);

  return {
    type,
    viewer,
    viewee,
    translationKeys,
  };
};

const graphesSerializer = ({ id, matrices, analysis }: IRawGraph): IGraph => ({
  id,
  matrices: matrices.map(matricesSerializer(id)),
  analysis,
});
